<template>
<div class="enroll-error">
  <div>
    <div>We're sorry, something went wrong. You may be already enrolled in the study.</div>
  </div>
</div>
</template>

<script>
export default {
  name: 'EnrollError',
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.enroll-error {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;
}

@media (min-width: $breakpoint-tablet) {
  .complete {
    justify-content: flex-start;
  }
}
</style>
